// import React from 'react';
// import { useAppDispatch } from '@store/hooks';
// import { useFormik } from 'formik';
// import { useTranslation } from 'react-i18next';
// import CustomAlert from '@components/Shared/Alert/CustomAlert';
// import { Form } from 'react-bootstrap';
// import { GetCurrenciesList, UpdateCurrencies } from '@store/NTX/Currency/currencySlice';

// interface props {
//   data: any;
// }

// const Update: React.FC<props> = ({ data }) => {
//   const dispatch = useAppDispatch();
//   const { t } = useTranslation();

//   const formik = useFormik({
//     initialValues: {
//       currencyCode: data.currencyCode ?? '',
//       description: data.description ?? '',
//       enabledFlag: data.enabledFlag ?? false
//     },
//     enableReinitialize: true,
//     onSubmit: values => {
//       dispatch(
//         UpdateCurrencies({
//           id: data.id ?? null,
//           currencyCode: values.currencyCode,
//           description: values.description,
//           enabledFlag: values.enabledFlag
//         })
//       )
//         .unwrap()
//         .then((res: any) => {
//           if (res?.succeeded === true) {
//             CustomAlert({ action: 'Edit' });
//             document.getElementById('closeModalForm')?.click();
//             dispatch(GetCurrenciesList());
//             formik.resetForm();
//           } else {
//             formik.setSubmitting(false);
//             CustomAlert({ action: 'Error', msg: res?.message });
//           }
//         })
//         .catch((error: any) => {
//           formik.setSubmitting(false);
//           CustomAlert({ action: 'Error' });
//         });
//     }
//   });
//   const { values, errors, touched, handleChange } = formik;

//   return (
//     <Form onSubmit={formik.handleSubmit}>
//       <div className='row'>
//         <div className='col-xl-12'>
//           <div className='form-group mb-3'>
//             <label className='form-label'>{t('CurrencyName')}</label>
//             <Form.Control
//               className='form-control'
//               type='text'
//               autoComplete='off'
//               name='description'
//               onChange={handleChange}
//               value={values.description}
//               isInvalid={!!(touched.description && errors.description)}
//             />
//             {/* <div className="text-danger small">{touched.description && errors.description}</div> */}
//           </div>
//         </div>

//         <div className='col-xl-12'>
//           <div className='form-group mb-3'>
//             <label className='form-label'>{t('CurrencyCode')}</label>
//             <Form.Control
//               className='form-control'
//               type='text'
//               autoComplete='off'
//               name='currencyCode'
//               onChange={handleChange}
//               value={values.currencyCode}
//               isInvalid={!!(touched.currencyCode && errors.currencyCode)}
//             />
//             {/* <div className="text-danger small">{touched.currencyCode && errors.currencyCode}</div> */}
//           </div>
//         </div>

//         <div className='col-xl-12'>
//           <div className='form-group mb-3'>
//             <Form.Check
//               style={{ margin: '10px 20px' }}
//               className='pt-1 pb-2 ms-auto'
//               type='checkbox'
//               label={t('Active')}
//               name='enabledFlag'
//               checked={formik.values.enabledFlag}
//               onChange={formik.handleChange}
//             />
//           </div>
//         </div>
//       </div>

//       <div className='text-center'>
//         <button disabled={formik.isSubmitting} type='submit' className='btn me-1 btn-theme mb-1'>
//           {formik.isSubmitting ? (
//             <div className='spinner-border spinner-border-sm me-2'></div>
//           ) : (
//             <i className='fa fa-save fa-fw me-1'></i>
//           )}
//           {t('Save')}
//         </button>
//         <button type='button' className=' btn me-1 btn-default mb-1' data-bs-dismiss='modal' id='closeModalForm'>
//           <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
//         </button>
//       </div>
//     </Form>
//   );
// };

// export default Update;

import React from 'react';
import { useAppDispatch } from '@store/hooks';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import { Form,   Badge } from 'react-bootstrap';
import { GetCurrenciesList, UpdateCurrencies } from '@store/NTX/Currency/currencySlice';
import { Card, CardBody } from '@components/card/card';

interface props {
  data: any;
}

const Update: React.FC<props> = ({ data }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const formik = useFormik({
    initialValues: {
      currencyCode: data.currencyCode ?? '',
      description: data.description ?? '',
      enabledFlag: data.enabledFlag ?? false
    },
    enableReinitialize: true,
    onSubmit: values => {
      dispatch(
        UpdateCurrencies({
          id: data.id ?? null,
          currencyCode: values.currencyCode,
          description: values.description,
          enabledFlag: values.enabledFlag
        })
      )
        .unwrap()
        .then((res: any) => {
          if (res?.succeeded === true) {
            CustomAlert({ action: 'Edit' });
            document.getElementById('closeModalForm')?.click();
            dispatch(GetCurrenciesList());
            formik.resetForm();
          } else {
            formik.setSubmitting(false);
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch((error: any) => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        });
    }
  });

  const { values, isSubmitting } = formik;

  return (
    <Form onSubmit={formik.handleSubmit}>
      <div className='row'>
        {/* بطاقة معلومات العملة */}
        <div className='col-xl-12 mb-4'>
          <Card className={`  shadow-sm ${values.enabledFlag ? 'border-success' : 'border-danger'}`}>
            <CardBody  >
              <div className='row align-items-center'>
                <div className='col-md-8'>
                  <div className='d-flex align-items-center mb-2'>
                    <h4 className='fw-bold text-dark mb-0 me-3'>{values.currencyCode}</h4>
                    <Badge bg={values.enabledFlag ? 'success' : 'danger'} className='fs-6'>
                      {values.enabledFlag ? t('مفعل') : t('معطل')}
                    </Badge>
                  </div>
                  <p className='text-muted mb-0 fs-5'>{values.description}</p>
                </div>
                <div className='col-md-4 text-end'>
                  <div className='currency-symbol-display'>
                    <span className='display-4 text-theme fw-bold'>{getCurrencySymbol(values.currencyCode)}</span>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>

        {/* تبديل حالة التفعيل فقط */}
        <div className='col-xl-12'>
          {/* <Card className='border-0 shadow-sm'> */}
            <CardBody className='p-4'>
              <div className='row align-items-center'>
                <div className='col-md-8'>
                  <h6 className='fw-semibold mb-1'>{t('Status')}</h6>
                  <p className='text-muted mb-0 small'>
                    {values.enabledFlag ? t('العملة مفعلة ومتاحة للاستخدام') : t('العملة معطلة وغير متاحة للاستخدام')}
                  </p>
                </div>
                <div className='col-md-4 text-end'>
                  <div className='form-check form-switch'>
                    <Form.Check
                      type='switch'
                      id='enabledFlag-switch'
                      className='fs-6'
                      name='enabledFlag'
                      checked={values.enabledFlag}
                      onChange={formik.handleChange}
                      style={{ transform: 'scale(1.5)' }}
                    />
                  </div>
                </div>
              </div>
            </CardBody>
          {/* </Card> */}
        </div>

        {/* رسالة توضيحية */}
        <div className='col-xl-12'>
          <div className='alert alert-info border-0'>
            <div className='d-flex align-items-center'>
              <i className='fas fa-info-circle fa-lg me-3 text-info'></i>
              <div>
                <h6 className='alert-heading mb-1'>{t('Note')}</h6>
                <p className='mb-0 small'>{t('يمكنك فقط تعديل حالة التفعيل/الإلغاء للعملة')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      {/* أزرار الإجراءات */}
      <div className='text-end pt-1'>
        <button disabled={isSubmitting} type='submit' className='btn btn-lg me-3 btn-theme px-4'>
          {formik.isSubmitting ? (
            <div className='spinner-border spinner-border-sm me-2'></div>
          ) : (
            <i className='fa fa-save fa-fw me-1'></i>
          )}
          {t('Save')}
        </button>

        <button
          type='button'
          className='btn btn-lg btn-outline-secondary px-4'
          data-bs-dismiss='modal'
          id='closeModalForm'
          disabled={isSubmitting}
        >
          <i className='fas fa-times me-2'></i>
          {t('Cancel')}
        </button>
      </div>
    </Form>
  );
};

// دالة مساعدة للحصول على رمز العملة
const getCurrencySymbol = (currencyCode: string) => {
  const symbols: { [key: string]: string } = {
    SAR: 'ر.س',
    USD: '$',
    EUR: '€',
    EGP: 'ج.م',
    CNY: '¥',
    JPY: '¥',
    QAR: 'ر.ق',
    GBP: '£',
    KWD: 'د.ك',
    OMR: 'ر.ع.',
    TRY: '₺',
    YER: 'ر.ي'
  };
  return symbols[currencyCode] || currencyCode;
};

export default Update;
